import React, {useContext, useEffect, useState} from 'react'
import s from '../styles/ApplicantProfile.module.scss'
import {CollegeCard} from 'Components/Tile/Card'
import Card from 'react-bootstrap/Card'
import {EditApplicantProfile} from './EditStudentApplicantProfile';
import {SessionContext} from 'Utils/sessions';
import avi from 'Static/default-avi.png'
import backgroundImg from 'Static/backgroundImg.png'
import {Root} from 'Root'
import {countries} from 'Utils/regions'
import {majors} from 'Utils/majors';
import SideBar from 'Components/Nav/SideBar';
import {CustomPagination} from 'Components/Pagination';
import {useRouteMatch} from 'react-router-dom'
import Spinner from 'react-bootstrap/esm/Spinner'

const AboutMe = ({session, profile, refreshSession, beginEditing}) => {
    return <Card className={`${s.infoCard} xlCard`}>
    <Card.Img className={s.cardImg} variant="top" src={backgroundImg} />
    <Card.Body>
        <div className='d-flex justify-content-center'>
            <div className={s.avi} style={{backgroundImage: `url(${profile.photo || avi})`, backgroundRepeat:'no-repeat', backgroundSize:'cover'}} />
        </div>
        <Card.Title className='text-center mb-0'>{profile.firstName} {profile.lastName}</Card.Title>
        <Card.Text className='text-muted text-center fs-13'>
            {profile && <span className='d-block'>{profile.city && profile.city !== 'N/A' && `${profile.city},`} {profile.country ==='US' && profile.state !== 'N/A' && profile.state} {profile.country !== 'US' && countries[profile.country]}</span>}
        </Card.Text>
        <Card.Text className='mt-3'>
            <strong>About Me</strong>
            <span className='d-block text-muted fs-13'>{profile.bio || '-'}</span>
        </Card.Text>
        <Card.Text>
            <strong>Username</strong>
            <span className='d-block text-muted fs-13'>{profile.userName || '-'}</span>
        </Card.Text>
        <Card.Text>
          <strong>Planned Major</strong>
          <span className='text-muted d-block fs-13'>{majors[profile.major] || '-'}</span>
      </Card.Text>
        {session && session.userName === profile.userName && <EditApplicantProfile profile={profile} session={session} refreshSession={refreshSession} beginEditing={beginEditing} />}
    </Card.Body>
    </Card>
};


const CollegeList = ({colleges, loading}) => {
    const [selected, setSelected] = useState(1)
    const itemsPerPage = 10
    return <>
    {loading && <Spinner style={{color:"rgb(16, 142, 115)"}} animation="border" role="status"/>}

    {colleges && <>
        {colleges.length === 0 ? <p className='fs-13 text-muted'>No Schools</p> : <div className={s.collegeList}>
        {colleges.slice((selected*itemsPerPage)-itemsPerPage, ((selected-1)*itemsPerPage) + itemsPerPage).map((c, idx) => {
            return <CollegeCard key={idx}  college={c}/>
            })}
            </div>}
        {colleges.length > itemsPerPage && <CustomPagination setSelected={setSelected} selected={selected} numPages={Math.ceil(colleges.length/itemsPerPage)}/>}
    </>}
</>
};

const StudentApplicantProfile = ({ userProfile, beginEditing }) => {
  const {session, refreshSession} = useContext(SessionContext)
  const [profile, setProfile] = useState({});
  const [favorites, setFavorites] = useState(null);
  const [favoritesError, setFavoritesError] = useState(null);
  const match = useRouteMatch();
  const userName = match.params.userName;

  useEffect(()=>{
      if (userProfile) {
          setProfile(userProfile)
      } else {
          Root.userApi.fetchStudentProfile(userName, session.jwt).then((res) => {
              setProfile(res.data)
          }).catch(() => {
              setProfile({})
          })
      }
  },[userProfile, userName, session.jwt])

  useEffect(()=>{
    Root.collegeApi.getFavorites(session.jwt).then((res) => {
          setFavorites(res.data)
    }).catch(() => {
        setFavorites([])
       setFavoritesError('Unable to get favorites, please try agan later')
    })
},[session.jwt])

  return <div>
        <SideBar title={"Profile"} session={session} search={false}>
            <div className={s.dashboardContent}>
                <div className={s.profileGrid}>
                    <div className={s.informationSection}>
                        {session.userName === profile.userName ?
                            <h2 className={'mb-4'}>Manage your profile</h2> :
                            <h2 className={'mb-4'}>Get to know {session.firstName}</h2>
                        }
                        <h3 className='heading mb-2'><strong>Information</strong></h3>
                        <AboutMe refreshSession={refreshSession} session={session} profile={profile}
                                 beginEditing={beginEditing}/>
                    </div>
                    <div className={s.favoriteCollegesSection}>
                        <h3 className='heading mb-2'><strong>Favorite Colleges</strong></h3>
                        {favoritesError && <p className='form-error fs-13'>{favoritesError}</p>}
                        <div className={s.favoriteCollegesList}>
                            {favorites ?
                                <>
                                    {favorites?.length === 0 ?
                                        <p className='fs-13 text-muted'>No Schools</p> :
                                        <div className={s.collegeList}>
                                            {favorites?.map((c, idx) => (
                                                <CollegeCard key={idx}  college={c}/>
                                            ))}
                                        </div>
                                    }
                                </>
                                :
                                <>
                                    <CollegeCard />
                                    <CollegeCard />
                                    <CollegeCard />
                                    <CollegeCard />
                                    <CollegeCard />
                                    <CollegeCard />
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </SideBar>
  </div>
}

export default (StudentApplicantProfile);
